import React from 'react';
import styles from './ItemControlModalCustom.module.scss';

const ItemControlModalCustom = ({ show, setShow, setSelectedIds, changeVisibilityOfItems, deleteItems, rows, selectedIds, isDelAction = undefined, isHideAction = undefined }) => {
   if (!show) return null;

   return (
      // <div className={styles.overlay} onClick={() => setShow(false)}>
      <div
         className={styles.modal}
      // onClick={(e) => e.stopPropagation()}
      >

         <div className={styles.main}>
            <div className={styles.main__block1}>
               <div className={styles.main__block1__selectedItems}>
                  <div className={styles.main__block1__selectedItems__cancelButton} onClick={() => setSelectedIds([])}>
                     <svg style={{ cursor: 'pointer' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </svg>
                  </div>
                  <div className={styles.main__block1__selectedItems__itemsQuantity}>
                     <span>{selectedIds?.length} selected</span>
                  </div>
               </div>
            </div>
            <div className={styles.main__block2}>
               <div
                  // className={styles.main__block2__actionContent}
                  className={`${styles.main__block2__actionContent} ${isHideAction === undefined ? styles.alignRight : ''}`}
               >
                  {isHideAction && <div className={styles.main__block2__actionContent__changeVisibility} onClick={() => changeVisibilityOfItems(selectedIds)}>
                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.833008 9.99992C0.833008 9.99992 4.16634 3.33325 9.99967 3.33325C15.833 3.33325 19.1663 9.99992 19.1663 9.99992C19.1663 9.99992 15.833 16.6666 9.99967 16.6666C4.16634 16.6666 0.833008 9.99992 0.833008 9.99992Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.99967 12.4999C11.3804 12.4999 12.4997 11.3806 12.4997 9.99992C12.4997 8.61921 11.3804 7.49992 9.99967 7.49992C8.61896 7.49992 7.49967 8.61921 7.49967 9.99992C7.49967 11.3806 8.61896 12.4999 9.99967 12.4999Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </svg>
                     <span>Change visibility</span>
                  </div>}
                  {isDelAction && <div
                     className={styles.main__block2__actionContent__delete}
                     onClick={() => deleteItems(selectedIds)}>
                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.3333 5.00008V4.33341C13.3333 3.39999 13.3333 2.93328 13.1517 2.57676C12.9919 2.26316 12.7369 2.00819 12.4233 1.8484C12.0668 1.66675 11.6001 1.66675 10.6667 1.66675H9.33333C8.39991 1.66675 7.9332 1.66675 7.57668 1.8484C7.26308 2.00819 7.00811 2.26316 6.84832 2.57676C6.66667 2.93328 6.66667 3.39999 6.66667 4.33341V5.00008M8.33333 9.58342V13.7501M11.6667 9.58342V13.7501M2.5 5.00008H17.5M15.8333 5.00008V14.3334C15.8333 15.7335 15.8333 16.4336 15.5608 16.9684C15.3212 17.4388 14.9387 17.8212 14.4683 18.0609C13.9335 18.3334 13.2335 18.3334 11.8333 18.3334H8.16667C6.76654 18.3334 6.06647 18.3334 5.53169 18.0609C5.06129 17.8212 4.67883 17.4388 4.43915 16.9684C4.16667 16.4336 4.16667 15.7335 4.16667 14.3334V5.00008" stroke="#EBA586" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </svg>
                     <span>Delete</span>
                  </div>}
               </div>
            </div>
         </div>
      </div>
      // </div>
   );
};

export default ItemControlModalCustom;
